// extracted by mini-css-extract-plugin
export default {"text__input__booking":"ReservationCommentary_text__input__booking__qdLOw"};